import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromAddress from './address.reducer';

export const selectAddressDataState =
  createFeatureSelector<fromAddress.AddressState>(
    fromAddress.addressFeatureKey,
  );

export const selectEnableAddressCollection = createSelector(
  selectAddressDataState,
  fromAddress.getEnableAddressCollection,
);

export const selectOriginalAddress = createSelector(
  selectAddressDataState,
  fromAddress.getOriginalAddress,
);

export const selectSuggestedAddress = createSelector(
  selectAddressDataState,
  fromAddress.getSuggestedAddress,
);

export const selectVerifiedAddressRequired = createSelector(
  selectAddressDataState,
  fromAddress.getVerifiedAddressRequired,
);

export const selectSelectedAddress = createSelector(
  selectAddressDataState,
  fromAddress.getSelectedAddress,
);
